import { Navigate, useSearchParams } from "react-router-dom";
import { usePermissions } from "@/hooks/use-permissions";
import { TimeImportTab } from "@/components/admin/TimeImportTab";
import { CommentsImportTab } from "@/components/admin/CommentsImportTab";
import { ImportGapTab } from "@/components/admin/ImportGapTab";
import { cn } from "@/lib/utils";

type TabKey = "time" | "comments" | "gap";

const TABS: Array<{ key: TabKey; label: string }> = [
  { key: "time", label: "Tidsregistreringer" },
  { key: "comments", label: "Prosjektoppdateringer" },
  { key: "gap", label: "Import-gap" },
];

export default function AdminImportPage() {
  const { isSuperadmin } = usePermissions();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: TabKey =
    tabParam === "comments" || tabParam === "time" || tabParam === "gap"
      ? tabParam
      : "time";

  if (!isSuperadmin) {
    return <Navigate to="/" replace />;
  }

  const setTab = (key: TabKey) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  return (
    <div className="px-6 py-6 space-y-6 max-w-5xl mx-auto">
      <div>
        <h1 className="font-display text-2xl tracking-tight">Importer fra Monday</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manuell import — ingen scheduled triggers. Kjør dry-run først for å
          se hva som matcher, og bekreft deretter.
        </p>
      </div>

      <div className="flex gap-2 border-b">
        {TABS.map((t) => {
          const active = t.key === activeTab;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={cn(
                "px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
                active
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {activeTab === "time" && <TimeImportTab />}
      {activeTab === "comments" && <CommentsImportTab />}
      {activeTab === "gap" && <ImportGapTab />}
    </div>
  );
}
